import React, { useEffect, useMemo, useState } from 'react';
import { ob } from '../../onboardingV2.tokens';
import { ConfettiLayer, Piece } from './SuccessHero.styles';

const PIECES = 28;
const LIFETIME_MS = 1700;

const prefersReducedMotion = () => {
    try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch {
        return false;
    }
};

const random = (min, max) => min + Math.random() * (max - min);

/** Pure CSS confetti (≤1.5s), not rendered with prefers-reduced-motion. */
const Confetti = () => {
    const [visible, setVisible] = useState(() => !prefersReducedMotion());

    const pieces = useMemo(
        () =>
            Array.from({ length: PIECES }, (_, index) => {
                const size = Math.round(random(6, 10));
                return {
                    key: index,
                    style: {
                        left: `${random(5, 95)}%`,
                        top: `${random(14, 30)}%`,
                        width: size,
                        height: index % 3 === 0 ? size * 1.6 : size,
                        borderRadius: index % 2 === 0 ? '50%' : '2px',
                        background: ob.confetti[index % ob.confetti.length],
                        '--dx': `${Math.round(random(-70, 70))}px`,
                        '--dy': `${Math.round(random(30, 60))}vh`,
                        '--duration': `${random(0.9, 1.4).toFixed(2)}s`,
                        '--delay': `${Math.round(random(0, 150))}ms`,
                    },
                };
            }),
        []
    );

    useEffect(() => {
        if (!visible) return undefined;
        const timer = window.setTimeout(() => setVisible(false), LIFETIME_MS);
        return () => window.clearTimeout(timer);
    }, [visible]);

    if (!visible) return null;

    return (
        <ConfettiLayer aria-hidden="true">
            {pieces.map((piece) => (
                <Piece key={piece.key} style={piece.style} />
            ))}
        </ConfettiLayer>
    );
};

export default Confetti;
